import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuthStatus, loginUser, logoutUser } from '../store/authSlice';

// AuthProvider now just kicks off the "am I already logged in?" check and
// renders its children. All auth state itself lives in the redux store, not
// in React context/state anymore.
export const AuthProvider = ({ children }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(checkAuthStatus());
    }, [dispatch]);

    return children;
};

// Same shape as before: { user, isAuthenticated, loading, login, logout }
// so Login.jsx, Header.jsx, PrivateRoute.js, etc. need no changes.
export const useAuth = () => {
    const dispatch = useDispatch();
    const { user, isAuthenticated, loading } = useSelector((state) => state.auth);

    const login = async (credentials) => {
        const result = await dispatch(loginUser(credentials));
        if (loginUser.fulfilled.match(result)) {
            return { success: true };
        }
        return { success: false, error: result.payload };
    };

    const logout = async () => {
        await dispatch(logoutUser());
    };

    return { user, isAuthenticated, loading, login, logout };
};